import { DateTime } from 'luxon';

export class DefaultWallClock {
  now() {
    return DateTime.now();
  }

  static instance = new DefaultWallClock();
}
